import PearFetch from '@bigo/pear-fetch';
import { isPartyHero } from '@/common/utils';

const pearConfigEnv = import.meta.env.VITE_BUILD_ENV === 'prod' ? 'prod' : 'gray';

const sameDomainPearFetch = new PearFetch({
  bizType: 'bigolive',
  // 本地开发没有 Pear 同域代理，部署环境则通过当前页面域名请求 Pear 数据。
  domain: import.meta.env.VITE_BUILD_ENV === 'dev' ? undefined : window.location.host,
});

/**
 * 对文本进行关键词替换
 */
const doReplacement = (text: string, replacement: Record<string, string>): string => {
  let _text = text;
  Object.keys(replacement).forEach((key) => {
    // 大小写不敏感 都会被匹配到
    _text = _text.replace(new RegExp(key, 'gi'), replacement[key]);
  });
  return _text;
};

/**
 * 补充处理 BIGO 文案，将其替换为 PartyHero
 */
const applyBigoToPartyHeroReplace = (langs: Record<string, string>): Record<string, string> => {
  if (!isPartyHero()) {
    return langs;
  }

  const replacement: Record<string, string> = {
    BIGO: 'PartyHero',
    Bigo: 'PartyHero',
    bigo: 'partyhero',
  };

  const result: Record<string, string> = {};

  Object.keys(langs).forEach((key) => {
    result[key] = doReplacement(langs[key], replacement);
  });

  return result;
};

/**
 * 在 partyHero 皮肤包下，对多语言文本进行品牌替换。
 * window.doInstallPackageReplace 由皮肤包注入，接受字符串并返回替换后的字符串。
 */
const applyPartyHeroReplace = (langs: Record<string, string>): Record<string, string> => {
  if (!isPartyHero() || typeof window.doInstallPackageReplace !== 'function') {
    return langs;
  }
  try {
    const replaced = window.doInstallPackageReplace(JSON.stringify(langs));
    const parsedLangs = JSON.parse(replaced);
    // 补充处理 BIGO 文案
    return applyBigoToPartyHeroReplace(parsedLangs);
  } catch {
    return langs;
  }
};

export const loadPearLocale = async (id: number, lang: string) => {
  const langs = await sameDomainPearFetch.fetch<Record<string, string>>({
    id,
    lang,
    pearEnv: pearConfigEnv === 'prod' ? '' : 'gray',
  });

  return applyPartyHeroReplace(langs);
};

export const loadPearConfig = async (id: number) => {
  return sameDomainPearFetch.fetch<Record<string, any>>({
    id,
    pearEnv: pearConfigEnv === 'prod' ? '' : 'gray',
  });
};
